import { memo } from 'react'

import Motion from '../Motion'
import FooterBottomBar from './includes/FooterBottomBar'
import FooterBottomSection from './includes/FooterBottomSection'
import FooterMiddleSection from './includes/FooterMiddleSection'
import FooterTopSection from './includes/FooterTopSection'

function WellBeingFooter() {
  return (
    <Motion
      as="footer"
      className="relative z-10 space-y-12 xl:space-y-8 pt-8 bg-[#E39FB7] text-white font-medium"
      transition={{ delay: 0.4 }}
    >
      <div className="flex flex-col w-full lg:flex-row md:justify-between md:pr-4 xl:pr-40 xl:pb-8">
        <FooterTopSection />
        <FooterMiddleSection />
        <FooterBottomSection />
      </div>
      <FooterBottomBar />
    </Motion>
  )
}

export default memo(WellBeingFooter)
